module.exports = {"370811002":"许庄街道","370811005":"李营街道","370811006":"南张街道","370811007":"仙营街道","370811008":"金城街道","370811009":"廿里铺街道","370811011":"古槐街道","370811012":"济阳街道","370811013":"阜桥街道","370811014":"越河街道","370811015":"观音阁街道","370811016":"南苑街道","370811017":"安居街道","370811018":"唐口街道","370811102":"长沟镇","370811109":"石桥镇","370811111":"喻屯镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370811.json
// module id = 1425
// module chunks = 0